import IconPHR from "./components/IconPHR";
import LoginForm from "./components/LoginForm";

const AuthenticationPage = () => {
  return (
    <div className="flex flex-col h-screen justify-center">
      <IconPHR />
      <LoginForm />
    </div>
  );
};

export default AuthenticationPage;
